import { FE_UPLT_HISTORY_TIMING_V2_250401 } from "@faire/retailer-settings/FE_UPLT_HISTORY_TIMING_V2_250401";
import {
  useAssignSetting,
  useSetting,
} from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";

export const useSettingUpltHistoryTimingV2 = () => {
  return useSetting(FE_UPLT_HISTORY_TIMING_V2_250401);
};

export const useAssignSettingUpltHistoryTimingV2 = () => {
  return useAssignSetting(FE_UPLT_HISTORY_TIMING_V2_250401);
};
